<template>
<div class="progress" @click="$emit('click')">
    <div v-for="(item, index) in buyProcessInfoList" :key="index" class="progress-item">
      <span class="progress-item-label">{{item.label}}</span>
      <span class="progress-item-dot"></span>
      <span class="progress-item-value">{{item.value}}</span>
    </div>
    <div class="progress-line"></div>
  </div>
</template>
<script>

import StoreManger from '@/utils/FundHQJHManger';
import JS from '../base/JSTool';

export default {
  name: 'ProgressLine',
  data() {
    return {
      pageData: {},
      buyProcessInfoList: [
        {
          label: '买入',
          value: '今日15点前',
        },
        {
          label: '确认份额',
          value: '05-04(星期五)',
        },
        {
          label: '查看盈亏',
          value: '05-04净值更新后',
        },
      ],
      fundCode: '',
      fundType: '',
    };
  },
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    const fundinfo = StoreManger.getFundJJXQ();
    this.pageData = fundinfo;
    this.handleDetail();
  },
  methods: {
    render() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      const fundinfo = StoreManger.getFundJJXQ();
      this.pageData = fundinfo;
      this.handleDetail();
    },
    handleDetail() {
      this.handleData(this.pageData);
    },
    handleData() {
      const BUYMARK = JS.fetchString(this.pageData, 'BUYMARK');
      const SSBCFDAY = JS.fetchString(this.pageData, 'SSBCFDAY');
      const CURRENTDAYMARK = JS.fetchString(this.pageData, 'CURRENTDAYMARK');

      let buySecondTime;
      let buyThirdTime;
      if (BUYMARK && BUYMARK !== '--') {
        [buySecondTime, buyThirdTime] = BUYMARK.split('|');
      } else if (SSBCFDAY && SSBCFDAY !== '--') {
        const tempDay = SSBCFDAY ? SSBCFDAY.slice(5) : '';
        const WeekDay = this.getWeekFromDate(SSBCFDAY);
        buySecondTime = `${tempDay} ${WeekDay}`;
        buyThirdTime = `${tempDay}净值更新后`;
      } else {
        buySecondTime = '--';
        buyThirdTime = '净值更新后';
      }
      if (!buySecondTime) {
        buySecondTime = '--';
      }
      const firstTime = CURRENTDAYMARK || '--';
      this.buyProcessInfoList = [
        { label: '买入', value: firstTime },
        { label: '确认份额', value: buySecondTime },
        { label: '查看盈亏', value: buyThirdTime },
      ];
    },
    getWeekFromDate(dateStr) {
      const num = new Date(dateStr).getDay();
      const weekDateList = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ];
      return weekDateList[num];
    },
  },
};
</script>

<style scoped lang="less">
.progress {
  padding: 30px 0px 30px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}

.progress-line {
  opacity: 0.2;
  background: #ff7748;
  border-radius: 100px;
  height: 6px;
  width: 98%;
  position: absolute;
  top: 87px;
  left: 1%;
}

.progress-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  &:nth-child(3) {
    align-items: flex-end;
  }
}

.progress-item-label {
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #000000;
  line-height: 30px;
}
.progress-item-dot {
  width: 14px;
  height: 14px;
  display: inline-block;
  border-radius: 50%;
  background: #ff6434;
  border: 4px solid #ffffff;
  z-index: 1;
  margin: 20px 0;
}

.progress-item-value {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 30px;
}
</style>
